import { get, post } from '@/util/auth'

export const getSalaryDeductionList = ({
  phoneNumber,
  invoiceId,
}: {
  phoneNumber: string
  invoiceId: number
}) => get(`app/${phoneNumber}/invoice/${invoiceId}`)

export const postApplication = ({
  phoneNumber,
  ...rest
}: {
  phoneNumber: string
  irId: number
  status: number
  amount: number
  vat: number
  comment: string
}) => post('app/' + phoneNumber + '/application', rest)
